import { Icon } from "@mirage-web/icons";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppSidebar } from "~/components/app-sidebar";
import { TrackPageView } from "~/components/track-page-view";
import { SidebarTrigger } from "~/components/ui/sidebar";
import { AppearanceSelect } from "~/modules/appearance/appearance-select";
import { getAuthStore } from "~/modules/auth/auth-store";
import { sessionStorageDef } from "~/modules/auth/credentials";
import { DocumentTitle } from "~/modules/page-title/document-title";

export const Route = createFileRoute("/_dash")({
  component: RouteComponent,
  async beforeLoad() {
    const profileResponse = await getAuthStore().ensureProfile();

    if (!profileResponse) {
      throw redirect({ to: "/" });
    }

    return { user: profileResponse.user };
  },
});

function RouteComponent() {
  const [session] = sessionStorageDef.use();

  const formatExpirationTime = (expiresAt: number) => {
    const date = new Date(expiresAt);
    return date.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const isSessionExpired = (expiresAt: number) => {
    return expiresAt < Date.now();
  };

  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden">
      <TrackPageView />
      <DocumentTitle />
      <div className="flex min-h-0 min-w-0 flex-1">
        <AppSidebar />
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <div className="bg-warning-muted border-b border-warning-border px-4 py-2 flex flex-wrap gap-3 items-center justify-between text-warning-foreground text-sm flex-shrink-0">
            <div className="flex items-center gap-2">
              <SidebarTrigger className="md:hidden" />
              <Icon name="warning" className="size-4 shrink-0" />
              <span>Be mindful when handling user data. All actions are logged.</span>
            </div>

            <div className="flex items-center gap-3">
              {session && (
                <div className="text-xs">
                  <span
                    className={isSessionExpired(session.expiresAt) ? "text-danger-foreground" : ""}
                  >
                    Active session expires {formatExpirationTime(session.expiresAt)}
                  </span>
                </div>
              )}
              <AppearanceSelect />
            </div>
          </div>
          <main className="min-w-0 grow overflow-x-hidden overflow-y-auto p-4">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
